import { action } from 'typesafe-actions'

import { AuditsActionTypes } from './types'
import { ResponseDataRequests } from '../requests/types'

interface Options {
  filterStatus?: string[]
  page: number
  request_numbers?: string
  traveler_name?: string
}

export const getAudits = (
  options: Options = {
    filterStatus: [],
    page: 1,
    request_numbers: '',
    traveler_name: '',
  }
) => action(AuditsActionTypes.GET_AUDITS, { options })

export const getAuditsSuccess = ({
  requests,
  request_totals,
  total_results
}: ResponseDataRequests) =>
  action(AuditsActionTypes.GET_AUDITS_SUCCESS, {
    requests,
    request_totals,
    totalResults: total_results
  })

export const getAuditsFailure = (message: string) =>
  action(AuditsActionTypes.GET_AUDITS_FAILURE, { message })
